/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { useNavigate } from 'react-router';
import { useStore } from '../store';
import './hot-topic-mobile-section.less';
interface IHotTopicMobileProps {
  HotTopicSections: any;
}

const HotTopicMobileSection: React.FunctionComponent<IHotTopicMobileProps> = ({
  HotTopicSections,
}) => {
  const navigate = useNavigate();
  const { language } = useStore();
  const getImg = (img: string) => require(`../../../assets/${img}`).default;
  const gotoCoursePage = (hottopic: string) => {
    navigate(`/${language}/hottopic/${hottopic}`);
  };

  return (
    <div
      className={`hot-topic-mobile-section ${HotTopicSections.title}`}
      style={{ backgroundColor: HotTopicSections.color }}
    >
      <div className="hot-topic-mobile-content">
        <p className="hot-topic-mobile-title">{HotTopicSections.title}</p>
        <p className="hot-topic-mobile-description">
          {HotTopicSections.description}
        </p>
        <div
          className="hot-topic-mobile-start-button"
          style={{
            borderColor: HotTopicSections.buttonColor,
            color: HotTopicSections.buttonColor,
          }}
          onClick={() => gotoCoursePage(HotTopicSections.page)}
        >
          <span>{HotTopicSections.button}</span>
        </div>
        <img
          className="hot-topic-mobile-img"
          src={HotTopicSections.pic && getImg(HotTopicSections.pic)}
          alt=""
        />
      </div>
    </div>
  );
};

export default HotTopicMobileSection;
